import React from 'react';
import PropTypes from 'prop-types';
import Color from 'swag-client-common/components/ui/color';
import classes from './color-selector.scss';
function ColorSelector(props) {
  const {
    seoSlug,
    colorFilterThumbnails,
    activeShadeIndex,
    onChangeActiveShadeIndex
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    id: `${seoSlug}-colors`,
    className: classes.itemColors
  }, colorFilterThumbnails.map((thumbnailData, index) => /*#__PURE__*/React.createElement(Color, {
    key: `${seoSlug}-${index}-${thumbnailData.color}`,
    isActive: index === activeShadeIndex,
    color: thumbnailData.color,
    name: thumbnailData.name,
    onClick: onChangeActiveShadeIndex,
    index: index,
    isActionable: true,
    showTooltip: true,
    className: classes.itemColor,
    activeClassName: classes.itemColorActive,
    clickableClassName: classes.itemColorClickable
  })));
}
ColorSelector.propTypes = {
  seoSlug: PropTypes.string.isRequired,
  colorFilterThumbnails: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  activeShadeIndex: PropTypes.number.isRequired,
  appliedFilter: PropTypes.shape({
    colorFilter: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onChangeActiveShadeIndex: PropTypes.func.isRequired
};
export default ColorSelector;